// A page's visit, read once: the campaign code and the class of the page
// before the visit's first page (src/core/campaign.ts has the rules). The
// tab keeps the two, and the code and the class a link carried are taken out
// of the address. The Studio's pages and the dock of a game's play page both
// read their visit here.

import { VISIT_KEY, readVisit, withVisit, type Visit } from "../core/campaign.ts";

let visit: Visit | null = null;

/** This page's visit. `home` is the Studio's host: this page's own, or the one a game host was told. */
export function currentVisit(home: string = location.hostname): Visit {
  if (visit) return visit;
  let kept: string | null = null;
  try {
    kept = sessionStorage.getItem(VISIT_KEY);
  } catch {
    // A browser that keeps nothing for the tab reads each page by itself.
  }
  const read = readVisit({ search: location.search, referrer: document.referrer, kept, home });
  visit = read.visit;
  try {
    sessionStorage.setItem(VISIT_KEY, read.keep);
  } catch {
    // (as above)
  }
  if (read.search !== location.search) {
    try {
      history.replaceState(history.state, "", `${location.pathname}${read.search}${location.hash}`);
    } catch {
      // The address stays as it came.
    }
  }
  return visit;
}

/** `url` with this page's visit on it: a link from the Studio's host to a game's address, or back. */
export const carry = (url: string): string => withVisit(url, currentVisit());
